// Polyfills

/**
 *  Object.create polyfill
 *
 *  @method  Object.create
 */
if (typeof Object.create !== "function") {
  Object.create = function(object) {
    function F() {}
    F.prototype = object;
    return new F();
  };
}

/**
 *  Object.watch polyfill
 *
 *  @method  Object.watch
 */
Object.defineProperty(Object.prototype, "bindWatch", {
  enumerable: false,
  configurable: true,
  writable: false,
  value: function(property, handler) {
    var previous = this[property];
    var current = previous;
    var getter = function() {
      return current;
    };
    var setter = function(value) {
      previous = current;
      return current = handler.call(this, property, previous, value);
    };
    // if (delete this[property]) {
    Object.defineProperty(this, property, {
      get: getter,
      set: setter,
      enumerable: true,
      configurable: true
    });
    // }
  }
});

/**
 *  Object.unwatch polyfill
 *
 *  @method  Object.unwatch
 */
if (!Object.prototype.unwatch) {
  Object.defineProperty(Object.prototype, "unwatch", {
    enumerable: false,
    configurable: true,
    writable: false,
    value: function(prop) {
      var val = this[prop];
      delete this[prop]; // remove accessors
      this[prop] = val;
    }
  });
}

/**
 *  String.toTitleCase polyfill
 *
 *  @method  Object.toTitleCase
 */
if (typeof String.toTitleCase !== "function") {
  String.prototype.toTitleCase = function() {
    var segments = this.split(/[\s_-]+/);
    var result = "";
    segments.forEach(function(word) {
      var length = word.length;
      var initial = word.slice(0, 1).toUpperCase();
      var remainder = word.toLowerCase().slice(1, length);
      result += " " + initial + remainder;
    });
    return result.slice(1, result.length);
  };
}

/**
 *  String.toInt shorthand
 *
 *  @method  Object.toInt
 */
if (typeof String.toInt !== "function") {
  String.prototype.toInt = function() {
    return window.parseInt(this, 10);
  };
}

/**
 *  Object.freeze polyfill
 *
 *  @method  Object.freeze
 */
if (typeof Object.freeze !== "function") {
  Object.freeze = function(object) {
    return object;
  };
}

/**
 *  Shorthand to query all elements by selector and return as an array
 *
 *  @method  document.queryAll
 */
if (!document.queryAll) {
  document.queryAll = function(selector, parent) {
    parent = parent || document;
    var elements;
    if (typeof selector === "string") {
      elements = parent.querySelectorAll(selector);
    } else if (selector instanceof HTMLElement) {
      elements = [selector];
    } else if (selector instanceof NodeList || selector instanceof Array) {
      elements = selector;
    } else {
      return console.warn("document.queryAll: `selector` is required!");
    }
    var count = elements.length;
    var result = [];
    for (var i = 0; i < count; i++) {
      result.push(elements[i]);
    }
    return result;
  };
}

/**
 *  Attach event handler to element(s)
 *
 *  @method  attachHandler
 */
function attachHandler(selector, handler, name, parent, preventDefault) {
  name = name || "click";
  preventDefault = preventDefault || true;
  var elements = document.queryAll(selector, parent);
  elements && elements.forEach(function(element, i) {
    element.addEventListener(name, function(event) {
      if (preventDefault && event.preventDefault) {
        event.preventDefault();
      }
      handler(event, i, elements);
    }, false);
  });
  return elements && elements.length === 1 ? elements[0] : elements;
}

/**
 *  Attach event handler to the document element
 *
 *  @method  attachHandler
 */
function attachDocumentHandler(selector, method, parent, preventDefault) {
  preventDefault = preventDefault || true;
  document.addEventListener("click", function(event) {
    var elements = document.queryAll(selector, parent);
    elements.forEach(function(element, i) {
      if (event.target == element) {
        if (preventDefault && event.preventDefault) {
          event.preventDefault();
          //event.stopPropagation();
        }
        method(event, i, elements);
      }
    });
  }, false);
}

/**
 *  Checks an element for a specific CSS class
 *
 *  @method  hasClass
 */
function hasClass(element, className) {
  return element.className.split(" ").indexOf(className) > -1;
}

/**
 *  Move an item in an array from one position to another
 *
 *  @method  Array.move
 */
if (!Array.move) {
  Array.prototype.move = function(previous, index) {
    if (index >= this.length) {
      var current = index - this.length;
      while ((current--) + 1) {
        this.push(undefined);
      }
    }
    this.splice(index, 0, this.splice(previous, 1)[0]);
    return this;
  };
}

/**
 *  Gets cumulative top/left offset of the element relative to the entire document
 *
 *  @param   {element}    element                 The element to measure
 *
 *  @method  cumulativeOffset
 */
function cumulativeOffset(element) {

  var top = 0;
  var left = 0;

  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent;
  } while (element);

  return {
    top: top,
    left: left
  };

}

/**
 *  Returns a RFC4122 Version 4 compliant UUID
 *
 *  @method  generateUUID
 */
function generateUUID() {

  var pattern = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";

  // Get current date time
  var date = new Date().getTime();

  // Check for high precision timer
  if (typeof performance !== "undefined" &&
    typeof performance.now === "function") {
    date += performance.now();
  }

  // Generate UUID
  return pattern.replace(/[xy]/g, function(char) {
    var rand = (date + Math.random() * 16) % 16 | 0;
    date = Math.floor(date / 16);
    return (char === "x" ? rand : (rand & 0x3 | 0x8)).toString(16);
  });

}

/**
 *  Returns a blob from a base64 string
 *
 *  @method  base64toBlob
 */
function base64toBlob(data, type, size) {

  type = type || "";
  size = size || 512;

  var characters = window.atob(data);
  var bytes = [];

  for (var offset = 0; offset < characters.length; offset += size) {
    var slice = characters.slice(offset, offset + size);
    var numbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      numbers[i] = slice.charCodeAt(i);
    }
    bytes.push(new Uint8Array(numbers));
  }

  return new Blob(bytes, {
    type: type
  });

}

/**
 *  Checks for localStorage support
 *
 *  @method  supportsLocalStorage
 */
function supportsLocalStorage() {
  try {
    var key = "-localstorage-test-";
    window.localStorage.setItem(key, key);
    window.localStorage.removeItem(key);
    return true;
  } catch (error) {
    var code = error.code === 22 // Error code for most browsers
      ||
      error.code === 1014; // Firefox only
    var name = error.name === "QuotaExceededError" // Error for most browsers
      ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED"; // Firefox only
    // TODO: Safari error beflow
    var length = window.localStorage.length !== 0; // Ensure contents
    return error instanceof DOMException && (code || name) && length;
  }
}

/**
 *  Clone an object
 *
 *  @method  clone
 */
function clone(object) {
  if (!object) return null;
  return JSON.parse(JSON.stringify(object));

}

// Math

// Clamp a number between two values
if (!Math.clamp) {
  Math.clamp = function(value, min, max) {
    return Math.min(Math.max(value, min), max);
  };
}

// Get a binomial coefficient
if (!Math.binom) {
  // rosettacode.org/wiki/Evaluate_binomial_coefficients
  Math.binom = function(n, k) {
    var coeff = 1;
    for (var i = n - k + 1; i <= n; i++) {
      coeff *= i;
    }
    for (var i = 1; i <= k; i++) {
      coeff /= i;
    }
    return coeff;
  };
}

// Round a number to a decimal
if (!Math.decimalRound) {
  Math.decimalRound = function(number, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  };
}
